import { configureStore } from '@reduxjs/toolkit';
import rootReducer from 'store/reducers';

const store = configureStore({
  reducer: rootReducer,
  devTools: true,
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof rootReducer>;

export default store;
